import { Navigate } from "react-router-dom";
import PropTypes from 'prop-types';

export const Authenticated = ({ component }) => {
    const UserData = localStorage.getItem("qtrackuser") && JSON.parse(localStorage.getItem("qtrackuser"))
    const isAuthenticated = UserData?.status
    return (
        isAuthenticated ? <Navigate to="/" /> : component 
    )
}

Authenticated.prototype = {
    component: PropTypes.element
}